import React from 'react';
import { ILogger } from '../log';

// 页面Context，注入一下通用的信息
export const PageContext = React.createContext({
    // 将logger挂在Context上面，方便维护一个logger队列，里面实现logger.sendShow、logger.sendClick、logger.sendPv的时序，去掉afterPv逻辑
    logger: null as ILogger,
});

export const usePageContext = () => {
    return React.useContext(PageContext);
};

export const PageContextProvider = PageContext.Provider;

export const PageContextConsumer = PageContext.Consumer;
